import { mapActions, mapGetters } from 'vuex';
import { smartbtoa } from '@/utils/helpers';

const disConfig = {
  api_key: process.env.DISQUS_PUBLIC_KEY,
  sso: {
    name: process.env.DISQUS_SSO_NAME,
    button: process.env.DISQUS_SSO_BUTTON,
    icon: process.env.DISQUS_SSO_ICON,
    url: process.env.DISQUS_SSO_URL,
    logout: process.env.DISQUS_SSO_LOGOUT,
    width: process.env.DISQUS_SSO_WIDTH,
    height: process.env.DISQUS_SSO_HEIGHT,
  },
};

function disqusConfig() {
  this.page.identifier = disConfig.identifier;
  this.page.url = disConfig.url;
  this.page.title = disConfig.title;
  this.page.api_key = disConfig.api_key;
  this.sso = disConfig.sso;

  this.page.remote_auth_s3 = disConfig.remote_auth_s3 ? disConfig.remote_auth_s3 : '';
}

export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    disqusId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    auth: String,
    url: String,
    marketId: {
      default: null,
    },
    previous: {
      default: null,
    },
    next: {
      default: null,
    },
    total: {
      default: null,
    },
  },
  data() {
    return {
      currentThread: null,
      currentTitle: this.title,
      previousThread: this.previous,
      nextThread: this.next,
      totalComments: this.total,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    ...mapGetters('user', ['isLoggedIn']),
  },
  mounted() {
    if (this.auth && this.isLoggedIn) {
      this.enableDisqus(this.auth);
    } else {
      this.enableDisqus(null);
    }
  },
  methods: {
    ...mapActions('market', ['getCommentThread']),
    reload(payload) {
      this.$router.push({
        name: this.$route.name,
        params: {
          ...this.$route.params,
          dontReload: true,
        },
        query: {
          ...this.$route.query,
          commentThreadId: payload.threadId,
        },
      });
      this.getCommentThread(payload)
        .then((data) => {
          this.currentTitle = data.disqus_ThreadName;
          this.nextThread = data.disqus_NextThreadID;
          this.previousThread = data.disqus_PrevThreadID;
          this.totalComments = data.disqus_ArchivedCommentsTotal;

          window.DISQUS.reset({
            reload: true,
            config() {
              this.page.identifier = data.disqus_Identifier;
              this.page.title = data.disqus_ThreadName;
              this.page.url = data.disqus_Url;
            },
          });
        });
    },
    onCurrent(commentThreadId) {
      const payload = {
        threadId: commentThreadId,
        marketId: this.marketId,
      };
      this.currentThread = commentThreadId;
      this.reload(payload);
    },
    onPrevious() {
      const payload = {
        threadId: this.previousThread,
        marketId: this.marketId,
      };
      this.currentThread = this.previousThread;
      this.reload(payload);
    },
    onNext() {
      const payload = {
        threadId: this.nextThread,
        marketId: this.marketId,
      };
      this.currentThread = this.nextThread;
      this.reload(payload);
    },
    enableDisqus(auth) {
      const shortname = process.env.DISQUS_SHORTNAME;
      const resolvedAuth = this.$router.resolve({
        name: 'disqus-auth',
      });
      const resolvedLogout = this.$router.resolve({
        name: 'disqus-logout',
        params: {
          routeName: smartbtoa(this.$route.name),
          routeParams: smartbtoa(JSON.stringify(this.$route.params)),
        },
      });

      disConfig.identifier = this.disqusId;
      disConfig.url = this.url || `${window.location.href}`;
      disConfig.title = this.title;
      disConfig.sso.width = this.isLayoutMobile ? 320 : 800;
      disConfig.sso.url = `${window.location.origin}${resolvedAuth.href}`;
      disConfig.sso.logout = `${window.location.origin}${resolvedLogout.href}`;
      // Note: SSO payloads expire after 2 hours. - now storing in ls
      disConfig.remote_auth_s3 = auth || '';

      if (window.DISQUS) {
        window.DISQUS.reset({
          reload: true,
          config: disqusConfig,
        });
      } else {
        window.disqus_config = disqusConfig;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `//${shortname}.disqus.com/embed.js`;
        document.body.appendChild(script);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/disqus/disqus.js